export default __webpack_public_path__ + "static/iLifeSavingRules-e03d3b23923fc15f4d96b74ef34eeae2.jpg";